import React, { useState } from 'react';
import './Flysafari.css';
import useScrollToTop from './ScrollToTop';
import { Link } from 'react-router-dom';
import { FaBus, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useTranslation, Trans } from 'react-i18next';



const DayAccordion = ({ item, isOpen, onClick }) => (
  <div className={`day-accordion${isOpen ? ' open' : ''}`}>
    <div className="day-header" onClick={onClick}>
      <h3>{item.icon} {item.day}</h3>
      <span className="toggle-icon">````
        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
      </span>
    </div>

    {isOpen && (
      <div className="day-content-row">
        <div className="day-text-content">
          <p className="highlight">{item.highlight}</p>
          <div className="details">
            {item.details.map((d, i) => <p key={i}>{d}</p>)}
          </div>
        </div>

      </div>
    )}
  </div>
);

const Flysafari = () => {
  useScrollToTop();
    const { t } = useTranslation('flysafari');
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="flysafari-container">
     <div className="feature-highlight">
  <h2>{t('featureHighlight.title')}</h2>
  <p>{t('featureHighlight.paragraph1')}</p>
  <p>{t('featureHighlight.paragraph2')}</p>
</div>


      {/* Itinerary Accordion */}
    <div className="accordion-wrapper">
  <h2 className="section-title">{t('itinerary.title')}</h2>
  {t('itinerary.days', { returnObjects: true }).map((item, index) => (
    <DayAccordion
      key={index}
      item={{
        ...item,
        icon: <FaBus /> // re-inject the icon manually
      }}
      isOpen={openIndex === index}
      onClick={() => toggleAccordion(index)}
    />
  ))}
</div>


      {/* Pricing */}
     <div className="pricing-section">
  <h2 className="section-title">{t('pricingSection.title')}</h2>

  <h3>{t('pricingSection.lowSeason')}</h3>
  <table className="pricing-table">
    <thead>
      <tr>
        <th>{t('pricingSection.table.groupSize')}</th>
        <th>{t('pricingSection.table.price')}</th>
      </tr>
    </thead>
    <tbody>
      {t('pricingSection.table.rows', { returnObjects: true }).map((row, i) => (
        <tr key={i}>
          <td>{row.group}</td>
          <td>{row.price}</td>
        </tr>
      ))}
    </tbody>
  </table>

  <h3>{t('pricingSection.peakSeason')}</h3>
  <table className="pricing-table">
    <thead>
      <tr>
        <th>{t('pricingSection.table.groupSize')}</th>
        <th>{t('pricingSection.table.price')}</th>
      </tr>
    </thead>
    <tbody>
      {t('pricingSection.table.rowsPeak', { returnObjects: true }).map((row, i) => (
        <tr key={i}>
          <td>{row.group}</td>
          <td>{row.price}</td>
        </tr>
      ))}
    </tbody>
  </table>

  <p className="note">{t('pricingSection.note')}</p>
</div>


      {/* Inclusions & Extras */}
     <div className="description-block">
  <h2>{t('descriptionBlock.titleIncluded')}</h2>
  <ul>
    {t('descriptionBlock.includedList', { returnObjects: true }).map((item, idx) => (
      <li key={idx}>{item}</li>
    ))}
  </ul>

  <h2>{t('descriptionBlock.titleOptional')}</h2>
  <ul>
    {t('descriptionBlock.optionalList', { returnObjects: true }).map((item, idx) => (
      <li key={idx}>{item}</li>
    ))}
  </ul>

  <div className="customize-button-wrapper">
    <Link to="/contact?source=Flying Safari" className="customize-button">
      {t('descriptionBlock.button')}
    </Link>
  </div>
</div>

    </div>
  );
};

export default Flysafari;
